// This file is generated during build process by: ./node-bin/gen-lab-version
export default {
  "repo": {
    "branch": "1.17.2",
    "commit": {
      "sha": "a0b4ec3d105e87d0beb4a0677b134429b02c22e8",
      "short_sha": "a0b4ec3",
      "url": "https://github.com/concord-consortium/lab/commit/a0b4ec3",
      "author": "Chris Hart",
      "email": "chart@concord.org",
      "date": "2020-07-09 15:56:57 -0400",
      "message": "Update version"
    },
    "last_tag": "1.17.2",
    "dirty": false
  }
};